export interface IPermissions {
  view: boolean;
  add: boolean;
  edit: boolean;
  remove: boolean;
}

export enum UserRole {
  Root = "root",
  Obchodnik = "obchodnik",
  Klient = "klient",
}

export interface IRolePermissions {}

export interface IRole {
  permissions: IRolePermissions;
  role: UserRole;
}

export type TViewPermission = {
  type: keyof IRolePermissions;
  permission?: (keyof IPermissions)[] | keyof IPermissions;
};

export const defaultPermissions: IPermissions = {
  add: false,
  edit: false,
  remove: false,
  view: false,
};

export const getAllRolePermissions = (): IRolePermissions => {
  return {};
};